export default __webpack_public_path__ + "static/media/doctor.25124f9c.png";